import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
  };
};

export const structure = (t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `en.message`,
        kind: "textArea",
        type: "text",
        label: `${t("push_notifications.notification_message_en")}*`,
        width: "47%",
        placeholder: t("push_notifications.write_notification_message_en"),
        colSpan: 6,
      },
      {
        name: `ar.message`,
        kind: "textArea",
        type: "text",
        label: t("push_notifications.notification_message_ar"),
        width: "47%",
        placeholder: t("push_notifications.write_notification_message_ar"),
        colSpan: 6,
      },
      // {
      //   name: `user_type`,
      //   kind: "radioBox",
      //   type: "text",
      //   label: "User type",
      //   width: "47%",
      //   placeholder: "Enter the price after discount",
      //   options: [
      //     { value: "1", label: "Customer" },
      //     { value: "2", label: "Driver" },
      //     { value: "3", label: "Any" },
      //   ],
      // },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    en: Yup.object().shape({
      message: Yup.string().required(t("common.required")),
    }),
    // ar: Yup.object().shape({
    //   message: Yup.string().required("Required"),
    // }),
    // user_type: Yup.string().required("required"),
  });
